import React, { useState } from 'react';
import {
  ListGroup,
  Card,
  ProgressBar,
  Badge,
  Collapse,
  Button,
  ListGroupItem,
  Spinner
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const PlansAnalista = ({
  size,
  countDraftPlan,
  countPlanApproval,
  countPlanApproved,
  countPlanDisapproved,
  countCustomerApproval,
  countPlanFinished,
  countPlanCancelled,
  loading
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const getValue = value => value ?? 0

  return (
    <Card className="shadow bg-white rounded mt-3 mb-3 card-style">
      <Card.Header>
        {t('label:plans')}
        <Button
          variant="light"
          size="sm"
          style={{ float: 'right' }}
          onClick={() => setOpen(!open)}
          aria-controls="example-collapse-text"
          aria-expanded={open}
          className={'btn-collapse'}
        >
          {' '}
          +
        </Button>
      </Card.Header>
      <Collapse in={open}>
      <Card.Body>
        <div className="mb-2">
          {t('statuses:draft')}
          <Badge variant="light" style={{ float: 'right' }}>
            {getValue(countDraftPlan)}
          </Badge>
          <ProgressBar striped variant="warning" now={getValue(countDraftPlan)} max={size}/>
        </div>

        <div className="mb-2">
          {t('statuses:on_approval')}
          <Badge variant="light" style={{ float: 'right' }}>
            {getValue(countPlanApproval)}
          </Badge>
          <ProgressBar striped variant="warning" now={getValue(countPlanApproval)} max={size}/>
        </div>

        <div className="mb-2">
          {t('statuses:disapproved')}
          <Badge variant="light" style={{ float: 'right' }}>
            {getValue(countPlanDisapproved)}
          </Badge>
          <ProgressBar striped variant="warning" now={getValue(countPlanDisapproved)} max={size}/>
        </div>

        <div className="mb-2">
          {t('statuses:in_customer_approval')}
          <Badge variant="light" style={{ float: 'right' }}>
            {getValue(countCustomerApproval)}
          </Badge>
          <ProgressBar
            striped
            variant="warning"
            now={getValue(countCustomerApproval)} max={size}
          />
        </div>

        <div className="mb-2">
          {t('statuses:approved')}
          <Badge variant="light" style={{ float: 'right' }}>
            {getValue(countPlanApproved)}
          </Badge>
          <ProgressBar striped variant="warning" now={getValue(countPlanApproved)} max={size}/>
        </div>

        <div className="mb-2">
          {t('statuses:finished')}
          <Badge variant="light" style={{ float: 'right' }}>
            {getValue(countPlanFinished)}
          </Badge>
          <ProgressBar striped variant="warning" now={getValue(countPlanFinished)} max={size}/>
        </div>

        <div className="mb-2">
          {t('statuses:canceled')}
          <Badge variant="light" style={{ float: 'right' }}>
            {getValue(countPlanCancelled)}
          </Badge>
          <ProgressBar striped variant="warning" now={getValue(countPlanCancelled)} max={size}/>
        </div>
      </Card.Body>
      </Collapse>
      <ListGroup variant="flush">
        <ListGroupItem>
          <b>{t('label:total plans')}:</b> {!loading ? size : (<>
                  <Spinner animation="border" style={{ color: '#e05c17' }} size='sm' />
                </>)}
        </ListGroupItem>
      </ListGroup>
    </Card>
  );
};

export default PlansAnalista;
